/**
 * Created by emma on 15/12/18.
 */
import $ from 'jquery';
export function in_array(arr, item, key = 'id') {
    var result = -1;
    if (arr && arr.length && typeof item != 'undefined') {
        $.each(arr, function (index, it) {
            if (typeof it != 'undefined') {
                if (typeof item == 'object') {
                    if (it[key] == item[key]) {
                        result = index;
                        return false;
                    }
                } else {
                    if (it[key] == item) {
                        result = index;
                        return false;
                    }
                }
            }
        });
    }
    return result;
}

export function getNameById(arr, id) {
    var name = '';
    arr.some(function (item) {
        if (item.id == id) {
            name = item.name;
            return true;
        }
    });
    return name;
}

export function isArray(value) {
    return Object.prototype.toString.call(value) == '[object Array]';
}


// WEBPACK FOOTER //
// ./components/util/array.js